import styled from "styled-components";

const ContextMenuOption = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  padding: 8px 11px;

  &:hover {
    background-color: #f0f0f0;
  }
`;

export default ContextMenuOption;
